<template>
  <div>
    <travel-service-menu />
    <travel-service-additional-parameters-dialog :dialog.sync="dialog" :model="dialogModel" @saved="downloadParamList" />
    <h1>{{ $t("travelService.additionalParametersList") }}</h1>
    <v-row no-gutters>
      <v-spacer />
      <div>
        <v-btn block color="accent" @click="dialog = true">{{ $t("global.add") }}</v-btn>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="additionalParameters">
      <template #item="props">
        <tr>
          <td class="text-left">
            <v-tooltip bottom>
              {{ $t("global.moveUp") }}
              <template #activator="{on}">
                <v-btn :disabled="props.item.ordinate === 1 || $store.getters['Ajax/loading']" @click="moveUp(props.item)" icon v-on="on">
                  <v-icon>fa-arrow-alt-circle-up</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            {{ props.item.ordinate }}
            <v-tooltip bottom>
              {{ $t("global.moveDown") }}
              <template #activator="{on}">
                <v-btn
                  :disabled="props.item.ordinate === additionalParameters.length || $store.getters['Ajax/loading']"
                  @click="moveDown(props.item)"
                  icon
                  v-on="on"
                >
                  <v-icon>fa-arrow-alt-circle-down</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
          <td class="text-left">
            {{ props.item.name }}
          </td>
          <td class="text-left">
            {{ props.item.default_value }}
          </td>
          <td class="text-left">
            {{ props.item.is_required ? $t("global.required") : $t("global.notRequired") }}
          </td>
          <td class="text-center">
            <v-tooltip bottom>
              {{ $t("global.edit") }}

              <template #activator="{on}">
                <v-btn v-on="on" @click="edit(props.item)" icon>
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn v-on="on" @click="remove(props.item)" icon>
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <v-alert slot="no-data" :value="loaded" color="info" icon="info">
        {{ $t("settings.travelService.noAcceptancePersons") }}
      </v-alert>
    </v-data-table>

    <v-alert color="info" :value="approvalUsers.length > 0" icon="info">
      {{ $t("settings.travelService.automaticApprovalInfo") }}
    </v-alert>
  </div>
</template>

<script>
import TravelServiceMenu from "../../../components/Settings/TravelService/TravelServiceMenu";
import TravelServiceAdditionalParametersDialog from "../../../components/Settings/TravelService/TravelServiceAdditionalParametersDialog";
export default {
  name: "SettingsTravelServiceAdditionalParametersView",
  components: { TravelServiceAdditionalParametersDialog, TravelServiceMenu },
  data: () => ({
    additionalParameters: [],
    approvalUsers: [],
    availableUsers: [],
    selectedUser: null,
    loaded: false,
    dialog: false,
    dialogModel: null
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("global.ordinate"), value: "ordinate" },
        { text: this.$t("global.name"), value: "name" },
        { text: this.$t("global.defaultValue"), value: "default_value" },
        { text: this.$t("global.isRequired"), value: "is_required" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  created() {
    this.downloadParamList();
  },
  methods: {
    downloadParamList() {
      this.axios.get("/settings/travel-service/get-additional-parameters").then(resp => {
        this.additionalParameters = resp.data;
      });
    },
    remove(item) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.travelService.removeAdditionalParamDialog.content"),
        title: this.$t("settings.travelService.removeAdditionalParamDialog.title")
      });
      dialog.then(() => {
        this.axios
          .post("/settings/travel-service/remove-additional-parameter", {
            additional_parameter_id: item.id
          })
          .then(() => {
            this.downloadParamList();
          });
      });
    },
    moveUp(item) {
      this.axios
        .post("/settings/travel-service/move-up-additional-parameter", {
          additional_parameter_id: item.id
        })
        .then(() => {
          this.downloadParamList();
        });
    },
    moveDown(item) {
      this.axios
        .post("/settings/travel-service/move-down-additional-parameter", {
          additional_parameter_id: item.id
        })
        .then(() => {
          this.downloadParamList();
        });
    },
    edit(item) {
      this.dialogModel = JSON.parse(JSON.stringify(item));
      this.dialog = true;
    }
  }
};
</script>

<style scoped></style>
